/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { ContentModuleModal, SortableList, ColorField } from '@molecules';

import Form from '../Form';
import { FORM_FIELD, INITIAL_VALUES } from './constants';
import Item from './Item';
import BlockForm from './BlockForm';
import BlockItem from './BlockItem';
import { Typography } from '@components/atoms';

const DualTextBlock = ({ visible = true, onSubmit, hide, previewImg, onDelete, initialValues: initData, errors }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const initialValues = React.useMemo(() => form.deserialize(initData || INITIAL_VALUES), [form, initData]);

  const [blocks, setBlocks] = React.useState(
    initialValues[FORM_FIELD.LEFT_CHILD.name] && initialValues[FORM_FIELD.RIGHT_CHILD.name]
      ? [initialValues[FORM_FIELD.LEFT_CHILD.name], initialValues[FORM_FIELD.RIGHT_CHILD.name]]
      : [],
  );

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const syncBlocks = React.useCallback(
    (_blocks) => {
      setBlocks(_blocks);
      form.setFields([{ name: [FORM_FIELD.LEFT_CHILD.name], value: _blocks[0] }]);
      form.setFields([{ name: [FORM_FIELD.RIGHT_CHILD.name], value: _blocks[1] }]);
    },
    [form, setBlocks],
  );

  const handleAdd = React.useCallback(
    (block) => {
      if (!form.getFieldValue(FORM_FIELD.LEFT_CHILD.name)) {
        return syncBlocks([block]);
      }
      return syncBlocks([form.getFieldValue(FORM_FIELD.LEFT_CHILD.name), block]);
    },
    [form, syncBlocks],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Dual Text Block"
      subtitle="Upload 2 text block"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD DUAL TEXT BLOCK'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      {blocks?.length < 2 && (
        <>
          <Typography.Title level={3}>Add a Single Text Block</Typography.Title>
          <BlockForm onSubmit={handleAdd} side="left" /* className={s.addForm} */ />
        </>
      )}
      <SortableList
        style={NO_MARGIN_BOTTOM}
        withPlaceholder
        value={blocks}
        label="Current blocks"
        withCount
        onChange={syncBlocks}
      >
        {(value, { edit, isEdit, save, buttons }) =>
          isEdit ? (
            <BlockForm onSubmit={save} initialValues={value} buttons={buttons} side="left" />
          ) : (
            <BlockItem item={value} handleEdit={edit}>
              {value?.title}
            </BlockItem>
          )
        }
      </SortableList>

      <Form
        form={form}
        onSerializedFinish={handleSubmit}
        layout="vertical"
        colon={false}
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
      >
        <Form.Item {...FORM_FIELD.LEFT_CHILD} style={{ display: 'none' }}></Form.Item>
        <Form.Item {...FORM_FIELD.RIGHT_CHILD} style={{ display: 'none' }}></Form.Item>
        <ColorField {...FORM_FIELD.BACKGROUND_COLOUR} style={{ marginTop: 20 }} />
      </Form>
    </ContentModuleModal>
  );
};

DualTextBlock.Item = Item;

export default DualTextBlock;
